import React, { useEffect, useState } from "react";
import * as image from "../../resources/images";
const MuduleChallengeContent = ({activityData, getMyActivity, loginType})=>{

    return(
      <>
        {(getMyActivity?.isCompleted || !loginType) ? (
        <div class="LessionDtlOverview m-0">
        <div class="d-flex align-items-start flex-wrap p-0">
          <div class="flex w-100 mb-3 align-items-start flex-wrap text-justify textcontentSidebar p-0">
            <p>
              <div className="module_challenge_ modulechallengeright">
                <h3 className="mb-2 h-3 fw-600">{activityData?.name}</h3>
                  <div className="how_challenges_work ">
                  <h4 className="mb-2">How the Challenge Works:</h4>
                  <ul>
                    {activityData?.instructions?.map((data, key) => (
                      <li key={key}>
                        <img src={image.starIcon} />
                        {data}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </p>
          </div>
        </div>
      </div>
        ):(
       <div className="module_challenge_ modulechallengeright">
      <div class="locked_Content">
      <div class="message_box"><p>
       <i class="fa-solid fa-circle-exclamation"></i></p>
       <p class="p1">Achieve all module objectives by completing the lessons to unlock the challenge.</p>
       </div>
       </div>
      </div>)
        }
     </>
    )
}
export default MuduleChallengeContent;